import React from "react";

const premiumImage = "/images/nav/gray/workspace-premium.svg";
interface UpsellBadgeProps {
    navigateToUpgradePage?: boolean;
}

abstract class UpsellBadge<P extends UpsellBadgeProps, S = {}, SS = any> extends React.PureComponent<P, S, SS> {    

    protected abstract getBadge(): JSX.Element;

    public render() {
        return (
            <span onClick={e => this.upsellBadgeNavigate()} className="upsell-badge">{this.getBadge()}</span>
        );
    }

    private upsellBadgeNavigate = () => {
        if (!this.props.navigateToUpgradePage) {
            return;
        }

        window.open("/Account/Upgrade");
    }
}

export class UpsellProBadge extends UpsellBadge<UpsellBadgeProps> {
    protected getBadge(): JSX.Element {
        return <img src={premiumImage} alt="Pro" />;
    }
}

export class UpsellApiBadge extends UpsellBadge<UpsellBadgeProps> {
    protected getBadge(): JSX.Element {
        return <img src={premiumImage} alt="API" />;
    }
}

export class UpsellScipBadge extends UpsellBadge<UpsellBadgeProps> {
    protected getBadge(): JSX.Element {
        return <img src={premiumImage} alt="SCIP" />;
    }
}
